import { render, staticRenderFns } from "./Taxcarddetails.vue?vue&type=template&id=6282b552&scoped=true"
import script from "./Taxcarddetails.vue?vue&type=script&lang=js"
export * from "./Taxcarddetails.vue?vue&type=script&lang=js"
import style0 from "./Taxcarddetails.vue?vue&type=style&index=0&id=6282b552&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6282b552",
  null
  
)

export default component.exports